export default __webpack_public_path__ + "static/media/MEDICALsmall.0813a621.png";